<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
        </div>
        <auth-component></auth-component>
    </section>
</template>
<script>
import Modal from "@/components/Modal.vue";
import AuthComponent from "../../layout/components/Auth/AuthComponent";

export default {
  components: {
    Modal,
    AuthComponent
  }
};
</script>
